import { render, staticRenderFns } from "./MyCstmrReg.vue?vue&type=template&id=595ae95c&"
import script from "./MyCstmrReg.vue?vue&type=script&lang=js&"
export * from "./MyCstmrReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports